import { Injectable } from '@angular/core';

/**
 * Schedules delayed chart transition callbacks and cancels stale ones when
 * data or filters change before animations complete.
 *
 * Register on the chart component via `providers: [ChartTransitionScheduler]`
 * so each chart instance gets its own pending-timeout state.
 */
@Injectable()
export class ChartTransitionScheduler {
  private pendingTimeouts: ReturnType<typeof setTimeout>[] = []

  cancel(): void {
    for (const id of this.pendingTimeouts) {
      clearTimeout(id)
    }
    this.pendingTimeouts = []
  }

  queue(callback: () => void, delay: number): void {
    const id = setTimeout(() => {
      this.pendingTimeouts = this.pendingTimeouts.filter(t => t !== id)
      callback()
    }, delay)
    this.pendingTimeouts.push(id)
  }
}
